<template>
  <div>
    <van-index-bar :index-list="Object.keys(cities)">
      <div v-for="(item, index) in cities" :key="index">
        <van-index-anchor :index="index"> </van-index-anchor>
        <van-cell
          @click="handleClick(i)"
          v-for="i in item"
          :key="i"
          :title="i"
        />
      </div>
    </van-index-bar>
  </div>
</template>

<script>
import { findGroup } from "@/api/wxapi.js";
import pinyin from "js-pinyin";
export default {
  data() {
    return {
      FirstPin: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "J",
        "K",
        "L",
        "M",
        "N",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "W",
        "X",
        "Y",
        "Z",
      ],
      cities: {},
      search: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClick(i) {
      wx.miniProgram.navigateTo({
        url:
          "/packageWebView/pages/yb-medicine-details/yb-medicine-details?drugName" +
          i,
      });
    },
    getList() {
      findGroup({
        pageNo: 1,
      }).then((res) => {
        var cities = res.data;
        let cityName = {};
        //循环26个字母的数组
        this.FirstPin.forEach((item) => {
          cityName[item] = [];
          cities.forEach((el) => {
            //对比开头字母是否对应
            let first = pinyin.getCamelChars(el).substring(0, 1).toUpperCase();
            if (first == item) {
              cityName[item] = [...cityName[item], el];
            }
          });
          if (!cityName[item].length) {
            delete cityName[item];
          }
        });
        this.cities = cityName;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-cell__title {
  span {
    font-size: 13px;
    font-weight: 500;
    color: #2f354d;
  }
}
/deep/.van-index-anchor {
  background-color: #f4f8fd !important;
  color: #9095a7;
}
/deep/.van-index-anchor--sticky {
  background-color: #f4f8fd !important;
  color: #9095a7;
}
/deep/.van-index-bar__sidebar {
  right: 10px;
}
/deep/.van-index-bar__index {
  padding: 0;
  margin-bottom: 4px;
  color: #9095a7;
  font-size: 12px;
  width: 15px;
  height: 15px;
  display: block;
  line-height: 16px;
  text-align: center;
  border-radius: 15px;
}
/deep/.van-index-bar__index--active {
  background: #4b84ff;
  color: #fff;
}
</style>